import Blue from "~/core";
import Swiper, { Navigation } from 'swiper';
Swiper.use([Navigation]);

new Blue({
	name: 'Carousel',
	selector: ".carousel",
	setup(carousel) {
		let container = carousel.querySelector(".carousel__swiper");
		let wrapper = carousel.querySelector(".carousel__wrapper");
		let slides = [...carousel.querySelectorAll(".carousel__slide")];
		let nextEl = carousel.querySelector('.swiper-button-next')
		let prevEl = carousel.querySelector('.swiper-button-prev')

		container.classList.add("swiper-container");
		wrapper.classList.add("swiper-wrapper");
		slides.forEach(s => s.classList.add('swiper-slide'))

		const swiper = new Swiper(container, {
			loopFillGroupWithBlank: true,
			// loop: true,
			navigation: {
				nextEl,
				prevEl
			},
			slidesPerView: 1,
			spaceBetween: 10,
			breakpoints: {
				1070: {
					slidesPerView: 2,
					spaceBetween: 40
				}
			}
		});
	}
});
